import { Card, Col, List, Row, Typography } from "antd";
import { useLottie } from "lottie-react";
import animationData from "../../../assets/json/Era.json";
// import "./buzzBucketHomepage.css";

const { Title } = Typography;
export const BuzzBucketHomePage = ({ handleQuestionSubmitted }) => {
  const options = {
    animationData: animationData,
    loop: true,
  };

  const { View, setSpeed } = useLottie(options, {
    width: "inherit",
    height: "13vh",
  });
  setSpeed(3);

  return (
    <div className="homepage">
      <Row align="middle" className="logo-show-home">
        <Col>
          <Row align="middle">
            <Col span={6}>{View}</Col>
            <Col span={18}>
              <Title className="logo-era-text">BuzzBucket</Title>
            </Col>
          </Row>
          <Row justify={"center"}>
            <Title level={3} className="logo-subtitle-text">
              Easebuzz Developer Solutions
            </Title>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

const ListCards = ({ data, handleQuestionSubmitted, className }) => {
  return (
    <List
      grid={{
        gutter: 16,
        xs: 1,
        sm: 2,
        md: 3,
        lg: 4,
        xl: 4,
        xxl: 4,
      }}
      className={className}
      dataSource={data}
      renderItem={(item) => (
        <List.Item className="list-cards">
          <Card
            className="questions-cards"
            onClick={() => handleQuestionSubmitted(item.question)}
          >
            <Title className="questions-cards-text">{item.question}</Title>
            <img
              className="questions-cards-img"
              alt={`${item.question}-img`}
              src={item.image}
            />
          </Card>
        </List.Item>
      )}
    />
  );
};
